// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__38cq_","loaderOuter":"PageOverlayLoader_loaderOuter__1AtMe"};